/**
 * DocumentPreview Component - Document preview modal
 */

import React from 'react'
import { Modal, Button } from '../ui'
import { Download, Eye, ExternalLink, FileText } from 'lucide-react'

const DocumentPreview = ({
  open,
  onClose,
  document,
  signedUrl = null,
  onDownload,
  ...props
}) => {
  if (!document) return null

  const isPdf = document.fileName?.toLowerCase().endsWith('.pdf')
  const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(document.fileName || '')

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={document.label || 'Document Preview'}
      description={`${document.fileName || 'No file'} · ${document.status || 'Unknown status'}`}
      size="lg"
      footer={
        <div className="flex gap-3">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          {signedUrl && (
            <Button
              variant="primary"
              icon={<ExternalLink size={16} />}
              onClick={() => window.open(signedUrl, '_blank')}
            >
              Open in New Tab
            </Button>
          )}
          {signedUrl && (
            <Button
              variant="outline"
              icon={<Download size={16} />}
              onClick={() => onDownload?.(document)}
            >
              Download
            </Button>
          )}
        </div>
      }
      {...props}
    >
      <div className="min-h-[300px] flex items-center justify-center bg-neutral-50 rounded-lg border border-neutral-200 p-4">
        {signedUrl ? (
          isPdf ? (
            <iframe
              src={`${signedUrl}#toolbar=0`}
              className="w-full h-[500px] rounded-lg"
              title={document.label}
            />
          ) : isImage ? (
            <img
              src={signedUrl}
              alt={document.label}
              className="max-w-full max-h-[500px] object-contain rounded-lg"
            />
          ) : (
            <div className="text-center">
              <FileText size={48} className="text-neutral-300 mx-auto mb-3" />
              <p className="text-sm text-muted">Preview not available for this file type</p>
              <p className="text-xs text-muted mt-1">{document.fileName}</p>
            </div>
          )
        ) : (
          <div className="text-center">
            <FileText size={48} className="text-neutral-300 mx-auto mb-3" />
            <p className="text-sm text-muted">No file uploaded</p>
            <p className="text-xs text-muted mt-1">Upload a file to preview it here</p>
          </div>
        )}
      </div>
    </Modal>
  )
}

DocumentPreview.displayName = 'DocumentPreview'

export default DocumentPreview